import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-8">Conditions Générales d'Utilisation</h1>
        
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Acceptation des Conditions</h2>
            <p>
              En accédant et en utilisant BrazzaBoost, vous acceptez d'être lié par ces conditions générales 
              d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre plateforme.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Description du Service</h2>
            <p>
              BrazzaBoost est une plateforme de mise en relation entre candidats et organisations offrant des 
              opportunités d'emploi, de stage, de formation, de volontariat et de bourses à Brazzaville.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. Compte Utilisateur</h2>
            <p className="mb-2">En créant un compte, vous vous engagez à :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fournir des informations exactes et à jour</li>
              <li>Maintenir la sécurité de votre mot de passe</li>
              <li>Informer immédiatement BrazzaBoost de toute utilisation non autorisée de votre compte</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Contenu Utilisateur</h2>
            <p>
              Vous êtes responsable du contenu que vous publiez sur la plateforme. Vous garantissez que votre 
              contenu ne viole aucune loi et ne porte pas atteinte aux droits de tiers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Utilisation Acceptable</h2>
            <p className="mb-2">Il est interdit de :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Publier des offres frauduleuses ou trompeuses</li>
              <li>Harceler ou discriminer d'autres utilisateurs</li>
              <li>Utiliser la plateforme à des fins illégales</li>
              <li>Collecter des données d'autres utilisateurs sans leur consentement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Publication d'Opportunités</h2>
            <p>
              Les organisations publiant des opportunités garantissent que leurs offres sont légitimes et conformes 
              aux lois du travail de la République du Congo.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Limitation de Responsabilité</h2>
            <p>
              BrazzaBoost agit uniquement comme intermédiaire. Nous ne sommes pas responsables des relations entre 
              candidats et organisations, ni de la véracité des offres publiées.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">8. Modification des Conditions</h2>
            <p>
              Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications prendront 
              effet dès leur publication sur la plateforme.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">9. Résiliation</h2>
            <p>
              Nous nous réservons le droit de suspendre ou de résilier votre compte en cas de violation de ces 
              conditions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">10. Contact</h2>
            <p>
              Pour toute question concernant ces conditions, contactez-nous à{' '}
              <a href="mailto:contact@brazzaboost.com" className="text-primary hover:underline">
                contact@brazzaboost.com
              </a>
            </p>
          </section>

          <p className="text-sm mt-8">
            Dernière mise à jour : 5 octobre 2025
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
